var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7938,
    cy: 11.7938,
    r: 11.0438,
    stroke: "#2B2B2B",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5979,
    cy: 11.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.4021,
    cy: 11.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.2062,
    cy: 11.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7938,
    cy: 37.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.598,
    cy: 37.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.4022,
    cy: 37.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.2062,
    cy: 37.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7938,
    cy: 63.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.598,
    cy: 63.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.4022,
    cy: 63.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.2062,
    cy: 63.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7938,
    cy: 89.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.598,
    cy: 89.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.4022,
    cy: 89.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.2062,
    cy: 89.7938,
    r: 11.7938,
    fill: "#2B2B2B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.c2b777d815c909c00ec194c523f73568.svg";
export { ForwardRef as ReactComponent };